import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigation } from '../contexts/NavigationContext';
import { FaUser, FaLock, FaEnvelope, FaPhone, FaWeixin, FaWhatsapp, FaFacebook, FaInstagram, FaArrowLeft } from 'react-icons/fa';

const RegisterPage = () => {
    // FIX: Destructure 'register' instead of 'signup' to match AuthContext
    const { register } = useAuth();
    const { navigateTo, currentPageData } = useNavigation();
    
    // Default role from navigation or null
    const [role, setRole] = useState(currentPageData?.role || null); 
    
    const [form, setForm] = useState({
        username: '', password: '', name: '',
        email: '', phone: '', wechat: '', whatsapp: '', facebook: '', instagram: ''
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const contacts = { 
            email: form.email.trim(), phone: form.phone.trim(), wechat: form.wechat.trim(), 
            whatsapp: form.whatsapp.trim(), facebook: form.facebook.trim(), instagram: form.instagram.trim() 
        };
        const hasContact = Object.values(contacts).some(v => v !== '');

        if (!hasContact) return alert("You must provide at least one contact method.");

        try {
            // FIX: Use the 'register' function defined in AuthContext
            // FIX: Pass 'email' explicitly at the top level so it is saved in the DB column
            await register({
                username: form.username,
                password: form.password,
                name: form.name,
                role: role,
                email: form.email.trim(), // Added explicit email field
                contactInfo: contacts
            });
            
            alert("Application Submitted! Please wait for approval.");
            navigateTo('login');
        } catch (err) {
            // Display the actual server error if it exists
            const errMsg = err.response?.data?.error || "Registration Failed. Please try again.";
            alert(errMsg);
        }
    };

    if (!role) {
        return (
            <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 gap-6">
                <h1 className="text-3xl font-black text-gray-800">Choose Account Type</h1>
                <div className="flex gap-4">
                    <button onClick={() => setRole('student')} className="p-8 bg-white border-t-4 border-blue-500 shadow-xl rounded-xl font-bold text-xl hover:scale-105 transition">Student</button>
                    <button onClick={() => setRole('teacher')} className="p-8 bg-white border-t-4 border-purple-500 shadow-xl rounded-xl font-bold text-xl hover:scale-105 transition">Teacher</button>
                </div>
                <button onClick={() => navigateTo('login')} className="text-gray-500 font-bold">Back to Login</button>
            </div>
        );
    }

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
            <div className="bg-white p-8 rounded-xl shadow-2xl w-full max-w-lg">
                <button onClick={() => setRole(null)} className="mb-4 flex items-center gap-2 text-gray-500 font-bold"><FaArrowLeft/> Back</button>
                <h2 className="text-2xl font-black mb-6 text-center">Apply as {role === 'student' ? 'Student' : 'Teacher'}</h2>
                
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div className="bg-gray-50 p-4 rounded border">
                        <label className="text-xs font-bold text-gray-400 uppercase">Login Info</label>
                        <div className="flex items-center border bg-white rounded mt-1 mb-2 px-2"><FaUser className="text-gray-400 mr-2"/><input className="w-full p-2 outline-none" placeholder="Username" value={form.username} onChange={e=>setForm({...form, username:e.target.value})} required/></div>
                        <div className="flex items-center border bg-white rounded px-2"><FaLock className="text-gray-400 mr-2"/><input className="w-full p-2 outline-none" type="password" placeholder="Password" value={form.password} onChange={e=>setForm({...form, password:e.target.value})} required/></div>
                    </div>

                    <input className="w-full p-2 border rounded" placeholder="Full Name" value={form.name} onChange={e=>setForm({...form, name:e.target.value})} required/>

                    <div className="grid grid-cols-2 gap-2">
                        <input className="p-2 border rounded text-sm" placeholder="Email" value={form.email} onChange={e=>setForm({...form, email:e.target.value})}/>
                        <input className="p-2 border rounded text-sm" placeholder="Phone" value={form.phone} onChange={e=>setForm({...form, phone:e.target.value})}/>
                        <input className="p-2 border rounded text-sm" placeholder="WeChat" value={form.wechat} onChange={e=>setForm({...form, wechat:e.target.value})}/>
                        <input className="p-2 border rounded text-sm" placeholder="WhatsApp" value={form.whatsapp} onChange={e=>setForm({...form, whatsapp:e.target.value})}/>
                        <input className="p-2 border rounded text-sm" placeholder="Instagram" value={form.instagram} onChange={e=>setForm({...form, instagram:e.target.value})}/>
                        <input className="p-2 border rounded text-sm" placeholder="Facebook" value={form.facebook} onChange={e=>setForm({...form, facebook:e.target.value})}/>
                    </div>

                    <button className="w-full bg-indigo-600 text-white py-3 rounded-lg font-bold hover:bg-indigo-700">Submit Application</button>
                </form>
            </div>
        </div>
    );
};

export default RegisterPage;